<h1>Page not found</h1>
<div id="not-found" />

<style type="text/scss">
  h1 {
    margin-bottom: 1rem;
  }

  #not-found {
    background-image: url(404.gif);
    background-size: cover;
    background-position: center;
    height: 100%;
  }
</style>
